import React, { Component } from "react";
import { TextField } from '@material-ui/core';

class InputRG extends Component {

    maskRG = value => {
        if (!value) {
            return null;
        }
        return value
            .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
            .replace(/(\d{3})(\d)\.(\d{3})(\d)/, '$1.$2') // captura os dois primeiros blocos de 3 dígitos
            .replace(/(\d{3})(\d)\.(\d{3})(\d)\.(\d{2})(\s)/, '$1-$2') // captura os dois primeiros blocos de 3 digitos e um bloco de 2 dígitos
            .replace(/(-\s)\s+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
    }
    
    handleRG = async e => {
        e.target.value = this.maskRG(e.target.value);
        this.props.onChange(e);
    }

    render() {
        return (
            <TextField
                minLength="10"
                variant={this.props.variant} 
                margin={this.props.margin} 
                fullWidth={this.props.fullWidth} 
                required={this.props.required} 
                label={this.props.label} 
                name={this.props.name}
                disabled={this.props.disabled}
                className={`MuiOutlinedInput-root ${this.props.className}`}
                autoComplete="documento"
                autoFocus
                onChange={this.handleRG}
                error={this.props.error}
                value={this.maskRG(this.props.value)}
                inputProps={{ maxLength: 25 }}
            />
        )
    }
}

export default InputRG;